import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class TableValidationModel extends ModeModelBase {
  override _name = 'tableValidation';
}

@Injectable({ providedIn: 'root' })
export class TableValidationModelAccessor extends ModelAccessorBase<TableValidationModel> {
  override name = 'tableValidation';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.tableValidation');
  }

  createModel(resource, opts?) {
    const model = new TableValidationModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
